/**
 * @file   古琴数字资源库-古琴
 * @create macaiqi 2025/06/12
 * @update 
 */
import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Bread from '../Bread';
import NavBar from '../NavBar';
import { Link, useLocation } from 'react-router-dom';
import { useNav } from '../../../App';
import './index.scss'
const GuQin = () => {
    let { pathname } = useLocation();
    const { navData } = useNav();

    let data = navData?.filter((item) => {
        return item.channelNo === pathname?.split("/")?.reverse()[0]
    })?.[0]

    return (
        <>
            <Header />
            <div className="guqin-page">
                {window.isWap && <NavBar title="古琴" />}
                <div className="content">
                    {!window.isWap && <Bread title="古琴" />}
                    <div className="list">
                        {data?.subChannel
                            ?.map((item, index) => {
                                return (
                                    <div className="item">
                                        <Link to={`/DigitalResourceLibrary/Guqin/${item?.channelNo}`} key={index} />

                                    </div>
                                )
                            })}
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default GuQin;